import React, { useState, useCallback } from 'react';
import Snackbar from '@fuww/library/src/Snackbar';

import TIMEOUT_FOR_REDIRECT from './lookbook/redirectTimeout';

const withNotification = (ComponentWithNotification) => (properties) => {
  const [message, setMessage] = useState(null);
  const [options, setOptions] = useState({});
  const notify = useCallback((newMessage, newOptions) => {
    setMessage(newMessage);
    setOptions(newOptions);
  }, []);
  const clear = useCallback(() => {
    setMessage(null);
    setOptions({});
  }, []);

  return (
    <>
      <ComponentWithNotification
        {...properties}
        notify={notify}
      />
      {message && (
        <Snackbar
          open
          onClose={clear}
          message={message}
          autoHideDuration={TIMEOUT_FOR_REDIRECT}
          {...options}
        />
      )}
    </>
  );
};

export default withNotification;
